import axios from "axios";
import genrateJWTToken from "./Services/singJwt";
export const onAppInit = async (context) => {
 
  try {
    let JWT = await genrateJWTToken({
      upn: context.username,
      unique_name:context.name,
    });

    const config = {
      headers: {
        "X-Custom-Header": JWT,
      },
    };
    const url = `${process.env.REACT_APP_API_END_POINT}/api/token`;
    const token = await axios.get(url, config);
    return token?.data;
  } catch (error) {
    return error;
  }
};